import { TronRes } from '~/utils/tron-v2'

export function useResourceTypeText(type: Ref<any>) {
  return computed(() => {
    return type.value === TronRes.BANDWIDTH ? $t('IgN1EoVRFTDyCVLbFG-oT') : $t('YUG0RoDj9Kcw8PtVRPR9Y')
  })
}
